export default {
  // 模块名称
  workshopRecord: {
    // 按钮类
    button: {
      query: '查询',
      reset: '重置',
      export: '导出',
      close: '关闭',
      detail: '查看'
    },
    // 文字标签类
    label: {
      name: '姓名',
      workNumber: '工号',
      phone: '电话',
      applicationWorkshop: '申请车间',
      entryTime: '进入时间',
      leaveTime: '离开时间',
      desc: '申请描述',
      status: '申请状态',
      operations: '操作',
      image: '图片'
    },
    // 提示类
    placeholder: {
      select: '请选择',
      startDate: '开始日期',
      endDate: '结束日期'
    },
    // 消息类
    message: {},
    // 标题类
    title: {
      detail: '记录详情'
    }
  }
}